module.exports = __webpack_public_path__ + "static/bg_green-80f5c84df7e806cf7300057a8aecfead.png";